import { db } from './db';
import { useStore } from './store';

let timer: number | undefined;
let lastSaved: unknown = null;

/** Saves the open project to IndexedDB shortly after each change. Call once at startup. */
export function startAutosave(): () => void {
  return useStore.subscribe((state, prev) => {
    if (state.projectHome !== 'local') return;
    if (!state.doc || !state.projectId || state.doc === prev.doc || state.doc === lastSaved) return;
    if (prev.projectId !== state.projectId) {
      lastSaved = state.doc;
      return;
    }
    useStore.getState().setSaveState('saving');
    window.clearTimeout(timer);
    const { doc, projectId } = state;
    timer = window.setTimeout(() => {
      db.projects
        .put({ id: projectId, name: doc.meta.name, updatedAt: Date.now(), doc })
        .then(() => {
          lastSaved = doc;
          if (useStore.getState().doc === doc) useStore.getState().setSaveState('saved');
        })
        .catch(() => useStore.getState().setSaveState('error'));
    }, 400);
  });
}
